import { IRIGranularities } from '@/utils/enum'
import { defaults } from 'lodash'

export const initialIRIState = {
  calibrations: [],
  devices: [],
  vehicles: [],
  segments: [],
  segment: null,
  granularity: IRIGranularities.HUNDRED_METERS,
  roadroidMeasurementsList: [],
}

export default defaults({}, initialIRIState)
